import { defineComponent, h } from 'vue';
import { QBanner, QIcon } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'form-help-dsgn',
    components: {
        QBanner,
        QIcon,
    },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        const type = this.designmodel?.color;
        let iconName = '';
        let bgColor = '';
        let textColor = '';

        if (type === 'warning') {
            bgColor = 'color-mix(in srgb, var(--v-outbound-base) 12%, transparent)';
            textColor = 'var(--v-outbound-base)';       
            iconName = 'mdi-alert';
        } 
        else if (typeof type === 'string' && type.startsWith('mdi')) {     
            bgColor = 'var(--v-activeBackground-base, #eef0ff)';
            textColor = 'var(--v-primary-base)';
            iconName = type.replace(/^\s*mdi\s+/, 'mdi-').trim() || 'mdi-information';
        } 
        else {
            bgColor = 'var(--v-activeBackground-base, #eef0ff)';
            textColor = 'var(--v-primary-base)';
            iconName = 'mdi-information';
        }

        const rawTitle = this.designmodel?.title;
        const rawBody = this.designmodel?.body;

        let titleNode;
        let bodyNode;

        const contentStyle = { 
            padding: '8px 0', 
            whiteSpace: 'normal', 
            wordBreak: 'break-word' 
        };

        // Apply new conditional rendering and padding logic
        if (rawTitle && rawBody) {
            titleNode = <div class="text-subtitle1" style={{ padding: 0 }}>{rawTitle}</div>;
            bodyNode = <div style={{ padding: 0 }}>{rawBody}</div>;
        } else if (rawTitle) {
            titleNode = <div style={{ padding: 0 }}>{rawTitle}</div>;
        } else if (rawBody) {
            bodyNode = <div style={{ padding: 0 }}>{rawBody}</div>;
        }

        const bannerClass = ['q-mb-sm', 'c-formHelp', 'rounded-borders'];
        const bannerStyle = {};

        if (bgColor) bannerStyle.backgroundColor = bgColor;
        if (textColor) bannerStyle.color = textColor;

        // Return the unique designer wrapper with the updated QBanner inside
        return (
            <div
                class={{ 'designer-form': true }}
                style={{ marginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QBanner
                    class={bannerClass.join(' ')}
                    style={bannerStyle}
                    v-slots={{
                        // Preserved the q-mr-md class from the original variation
                        avatar: () => <QIcon name={iconName} size="sm" class="q-mr-md" />,
                    }}
                >
                    <div style={contentStyle}>
                        {titleNode}
                        {bodyNode}
                    </div>
                </QBanner>
            </div>
        );
    }
});